import type { EIRData } from 'types';
import type { AppState, AppAction } from '../appReducerTypes';

export function ehrReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'SET_DATA':
      return {
        ...state,
        data: action.payload,
        filteredEntries: action.payload.entries,
        error: null,
      };
    case 'SET_FILTERED_ENTRIES':
      return { ...state, filteredEntries: action.payload };
    case 'SET_VIEW':
      return { ...state, currentView: action.payload };
    case 'SET_FILTERS':
      return {
        ...state,
        filters: { ...state.filters, ...action.payload },
      };
    case 'CLEAR_FILTERS':
      return {
        ...state,
        filters: {
          category: '',
          provider: '',
          status: '',
          startDate: '',
          endDate: '',
          searchTerm: '',
        },
      };
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };
    case 'ADD_CLINICAL_ENTRY':
      if (!state.data) {
        const newData: EIRData = {
          entries: [action.payload],
          metadata: {
            format_version: '1.0',
            created_at: new Date().toISOString(),
            source: 'EIR AI Assessment',
          },
        };
        return {
          ...state,
          data: newData,
          filteredEntries: [action.payload],
        };
      }
      return {
        ...state,
        data: {
          ...state.data,
          entries: [...state.data.entries, action.payload],
        },
        filteredEntries: [...state.filteredEntries, action.payload],
      };
    case 'UPDATE_CLINICAL_ENTRY':
      if (!state.data) return state;
      return {
        ...state,
        data: {
          ...state.data,
          entries: state.data.entries.map((entry) =>
            entry.id === action.payload.id ? action.payload : entry
          ),
        },
        filteredEntries: state.filteredEntries.map((entry) =>
          entry.id === action.payload.id ? action.payload : entry
        ),
      };
    case 'DELETE_CLINICAL_ENTRY':
      if (!state.data) return state;
      return {
        ...state,
        data: {
          ...state.data,
          entries: state.data.entries.filter((entry) => entry.id !== action.payload),
        },
        filteredEntries: state.filteredEntries.filter((entry) => entry.id !== action.payload),
      };
    case 'MERGE_DATA': {
      if (!state.data) {
        return {
          ...state,
          data: action.payload,
          filteredEntries: action.payload.entries || [],
        };
      }
      const existingIds = new Set(state.data.entries.map((e) => e.id));
      const newEntries = (action.payload.entries || []).filter((e) => !existingIds.has(e.id));
      const mergedEntries = [...state.data.entries, ...newEntries];
      return {
        ...state,
        data: {
          ...state.data,
          entries: mergedEntries,
          metadata: {
            ...state.data.metadata,
            ...action.payload.metadata,
            lastSyncTime: new Date().toISOString(),
          },
        },
        filteredEntries: mergedEntries,
      };
    }
    case 'UPDATE_METADATA': {
      if (!state.data) return state;
      return {
        ...state,
        data: {
          ...state.data,
          metadata: {
            ...state.data.metadata,
            ...action.payload,
          },
        },
      };
    }
    default:
      return state;
  }
}
